module.exports = __webpack_public_path__ + "briefcase.svg?5111eaf0bacbee3f5224d48807587f4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/briefcase.svg
// module id = 110
// module chunks = 0